// The cross at the top right corner of a block the player can close: a wheel
// card that is open, and a dialog. A card that no click closes has none.

import { el } from '../lib/dom';
import { svg } from '../lib/svg';

const CLOSE_LABEL = 'Close';
const ICON_BOX = 16;
const CROSS = 'M4 4 L12 12 M12 4 L4 12';

export const createCloseButton = (onClose: () => void): HTMLButtonElement =>
  el(
    'button',
    {
      className: 'close-button',
      type: 'button',
      ariaLabel: CLOSE_LABEL,
      onclick: onClose,
      // A card the player can drag starts a drag on a press. A press on the cross is not a drag.
      onpointerdown: (event: PointerEvent) => event.stopPropagation(),
    },
    [
      svg(
        'svg',
        {
          class: 'close-button__icon',
          viewBox: `0 0 ${ICON_BOX} ${ICON_BOX}`,
          'aria-hidden': 'true',
        },
        [svg('path', { d: CROSS })],
      ),
    ],
  );
